import React, { useState, useEffect } from "react"; 
import "video-react/dist/video-react.css"; // Import styles for video-react

const LazyVideoPlayer = ({ videoUrl }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [Player, setPlayer] = useState(null);

  // Dynamically import the Player component when the component mounts
  useEffect(() => {
    const loadPlayer = async () => {
      const { Player } = await import("video-react");
      setPlayer(() => Player);  // Set the Player dynamically
      setIsLoading(false);  // Hide loading indicator once it's ready
    };

    loadPlayer();
  }, []);

  return (
    <div style={{ textAlign: "center", maxWidth: "800px", margin: "auto" }}>
      <div style={{ position: "relative", marginBottom: "20px" }}>
        {/* Loading Indicator */}
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
              color: "#fff",
              background: "rgba(0, 0, 0, 0.5)",
              padding: "10px 20px",
              borderRadius: "5px",
            }}
          >
            Loading...
          </div>
        )}

        {/* Render the Player when it's loaded */}
        {Player && (
          <Player
            src={videoUrl}
            onCanPlay={() => setIsLoading(false)} // Trigger when video can play
            onWaiting={() => setIsLoading(true)} // Trigger when video buffers
          />
        )}
      </div>
    </div>
  );
};

export default LazyVideoPlayer;
